export const CityFeedback = ({ city }) => (
<>
<h4 className="text-xl font-bold text-yellow-400 mt-6 mb-3">
                      Témoignages Clients à {city}
                    </h4>
                    
                    <p className="text-base md:text-lg">
                      Les résultats parlent d'eux-mêmes à {city}. Marie, 32 ans de {city}, témoigne : 
                      "Après 8 mois de séparation, le rituel de retour affectif de Maître Diamma a ramené mon ex en seulement 5 jours. 
                      C'est le meilleur marabout africain de {city}." Jean, 45 ans de {city}, confirme : 
                      "J'étais victime d'un envoûtement qui détruisait ma vie. Le désenvoutement de Maître Diamma m'a complètement libéré. 
                      Un vrai sorcier vaudou à {city}." Maître Diamma annonce au total 280 clients satisfaits en Guadeloupe pour ses services de 
                      <strong className="text-white">grand marabout africain</strong>.
                    </p>
</>
);
